import { render, staticRenderFns } from "./SinglePost.vue?vue&type=template&id=6ccb0452&scoped=true&"
import script from "./SinglePost.vue?vue&type=script&lang=js&"
export * from "./SinglePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb0452",
  null
  
)

export default component.exports